import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FilesInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { extname } from 'path';
import { RepresentationDTO, RepresentStatusUpdateDto } from './dto/reprentation.dto';
import { AllRepresentationResponseModel, RepresentationResponseModel, SignalRepresentationResponseModel } from './representation-response-module';
import { RepresentationService } from './representation.service';
import { diskStorage } from 'multer';
import { imageFileFilter } from '../shared/file-upload';
@ApiTags('Representation')
@Controller('representation')
export class RepresentationController {
    constructor (
        private RepresentationService: RepresentationService,
    ){}

    /**
     * create text/url post 
     * @param queryParam which returns api version
     * @param postDto which passes details to be saved
     * @param request which returns headers 
     * @returns postResponse which returns the updated data along with status (true/false), errortype, intlcode, internal message which provides message the calling function.   
     */
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createRepresentation') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/representationImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createRepresentation(@Query() queryParam,@UploadedFiles() attachments,@Body() RepresentationDTO:RepresentationDTO,@Req() request:Request): Promise<RepresentationResponseModel> {
        try {
            const representationfilesData = await this.RepresentationService.createrepresentation(queryParam, RepresentationDTO);
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {                   
                    representationId:representationfilesData.Id,
                    attachmentsUrl: `representation/representationImages/${file.filename}`
                };
                response.push(fileReponse);
            })
            return await this.RepresentationService.createrepresentationfiles(queryParam, response,representationfilesData.Id);
        } catch (error) {
            return errorHandler(RepresentationResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateRepresentation') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/representationImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async updateRepresentation(@Query() queryParam,@UploadedFiles() attachments,@Body() RepresentationDTO:RepresentationDTO,@Req() request:Request): Promise<RepresentationResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {                   
                    representationId:RepresentationDTO.Id,
                    attachmentsUrl: `representation/representationImages/${file.filename}`,
                };
                response.push(fileReponse);
            })
            return await this.RepresentationService.updateRepresentation(queryParam, response,RepresentationDTO);
        } catch (error) {
            return errorHandler(RepresentationResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAllActiveRepresentation/:userId')
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'}) 
    @ApiParam({name:'userId'})   
    async getAllActiverepresentation(@Query() queryParams, @Param('userId') userId, @Req() request:Request):Promise<AllRepresentationResponseModel> {
        try {           
            return await this.RepresentationService.getAllActiverepresentation(queryParams,userId,request);
        } catch (error) {
            return errorHandler(AllRepresentationResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getRepresentationById/:Id')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Id'})
    async getRepresentationById(@Query() queryParams,@Param('Id') Id, @Req() request:Request):Promise<SignalRepresentationResponseModel> {
        try {
            return await this.RepresentationService.getRepresentationById(queryParams,Id,request);
        } catch (error) {
            return errorHandler(SignalRepresentationResponseModel, error);
        }
    }

    @Get('representationImages/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedFile(@Param('imgpath') attachments, @Res() res) {
		try {
            return res.sendFile(attachments, { root: './public/representationImages' });
		} catch (error) {
			return error.message;
		}
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateRepresentStatus')
    @ApiQuery({name:'apiVersion'})
    async updateRepresentStatus(@Query() queryParams, @Body() RepresentStatusUpdateDto: RepresentStatusUpdateDto, @Req() request: Request): Promise<RepresentationResponseModel> {
        try {   
            return await this.RepresentationService.updateRepresentStatus(queryParams,RepresentStatusUpdateDto, request);
        } catch (error) {
            return errorHandler(RepresentationResponseModel, error);
        }
    }   
}
